import { useTranslate } from "@similarweb/i18n-provider";
import { AlertBanner } from "@similarweb/ui-components";

export const NoDataAlert = () => {
    const { translate } = useTranslate();

    return (
        <AlertBanner
            variant="info"
            data-automation="gsc-no-data-alert"
        >
            <AlertBanner.Image />
            <AlertBanner.Description>{translate("rankTracker.gsc.noData")}</AlertBanner.Description>
        </AlertBanner>
    );
};
